import React, { useEffect, useState } from 'react'
import { Box, Grid, IconButton, Pagination, Stack, useTheme } from '@mui/material';
import route from '../../../utils/Routes';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import ScrollBox from '../../../components/ScrollBox';
import ProductCard from '../../../components/ProductCard';
import SwapVertOutlinedIcon from '@mui/icons-material/SwapVertOutlined';
import SearchTxtField from '../../../components/SearchTxtField';
import BackButton from '../../../components/BackButton';
import { getSingleCatServ } from '../../../services/amtc-service';
import { isNotEmpty } from '../../../utils/format';
import { useAuthContext } from '../../../context/AuthContext';
import { useQuery } from 'react-query';
import QueryKey from '../../../utils/QueryKey';
import { customAlert } from '../../../components/notify';
import PathBtns from '../../../components/PathBtns';
import { getComProdServ } from '../../../services/com-service';



function ComProductListPage({ type = 'amtc' }) {
    const navigate = useNavigate();
    const theme = useTheme();
    const { setLoadingScreen, ctxtUser, setNavComValue } = useAuthContext();
    const location = useLocation();
    const limit = 12;
    const [order, setOrder] = useState('desc');
    const [searchParams, setSearchParams] = useSearchParams();
    const qcomId = searchParams.get("comId");
    const qCatId = searchParams.get("catId");
    const qSubCatId = searchParams.get("subCatId");
    const pgNo = parseInt(searchParams.get("pgNo") || "1");
    const querySearchWord = searchParams.get("s") || "";
    const [searchWord, setSearchWord] = useState(decodeURIComponent(querySearchWord) || "");
    const [isSrchBtnClick, setIsSrchBtnClick] = useState(0)
    const isSrchRes = parseInt(searchParams.get("isSrchRes") || "0");
    const comId = type === 'amtc' ? qcomId : ctxtUser?.comId;

    const { isLoading: isProdLoading, isError: isProdErr, error: prodErr, data: prodData } = useQuery([QueryKey.comProd, comId, pgNo, qCatId, qSubCatId, order, isSrchBtnClick],
        () => getComProdServ({ comId, catId: qCatId, subCatId: qSubCatId, pageNumber: pgNo, searchKeyWord: searchWord, order, limit }), {
        enabled: ((isNotEmpty(qCatId) || isNotEmpty(qSubCatId)) && isNotEmpty(comId)),
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        keepPreviousData: true
    });

    const { isLoading, isError, error, data: catData } = useQuery([QueryKey.singleCat, comId, qCatId, qSubCatId], () => getSingleCatServ(qCatId || qSubCatId),
        {
            enabled: ((isNotEmpty(qCatId) || isNotEmpty(qSubCatId)) && isNotEmpty(comId)),
            refetchOnMount: true,
            refetchOnWindowFocus: false,
        })



    const pathBtnsArr = type === 'amtc' ? [{
        label: "Category",
        handleClick: () => navigate(`${route.aCompany}/?comId=${comId}&tab=2`)
    },
    ...(qSubCatId ? [{
        label: catData?.parCatName,
        handleClick: () => navigate(`${route.aComSubcategory}/?catId=${catData?.parentId}&catName=${catData?.parCatName}&comId=${comId}`)
    }, {
        label: catData?.catName,
        handleClick: () => { }
    }] : [{
        label: catData?.catName,
        handleClick: () => { }
    }])] : [{
        label: "Category",
        handleClick: () => navigate(`${route.comCataLog}`)
    },
    ...(qSubCatId ? [{
        label: catData?.parCatName,
        handleClick: () => navigate(`${route.cSubCatList}/?catId=${catData?.parentId}&catName=${catData?.parCatName}`)
    }, {
        label: catData?.catName,
        handleClick: () => { }
    }] : [{
        label: catData?.catName,
        handleClick: () => { }
    }])]

    useEffect(() => {
        setNavComValue({ comId })
        return () => setNavComValue({ comId: "" }); // Reset when leaving the page
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, comId]);

    useEffect(() => {
        setLoadingScreen(isProdLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isProdLoading]);

    useEffect(() => {
        setLoadingScreen(isLoading);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading]);

    useEffect(() => {
        if (!qCatId && !qSubCatId) {
            navigate("/", { replace: true });
        }
    }, [qCatId, qSubCatId, navigate]);




    const handlePageChange = async (event, value) => {
        //    setPageNumber(value);
        setSearchParams(prev => {
            prev.set("pgNo", value)
            return prev
        }, { replace: true })
    };

    async function onOrderChange(e) {
        if (order === "desc")
            setOrder("asc");
        else
            setOrder("desc");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            return prev
        }, { replace: true })
    }

    async function onSearchBtnClick(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("isSrchRes", 1)
            return prev
        }, { replace: true })
    }

    function onSearch(e) {
        setSearchWord(e.target.value)
        setSearchParams(prev => {
            prev.set("s", encodeURIComponent(e.target.value))
            return prev
        }, { replace: true })
    }

    // function handleDDChange(e) {
    //     setSearchParams(prev => {
    //         prev.set("st", e.target.value)
    //         return prev
    //     }, { replace: true })
    // }

    function handleOnClear(e) {
        setIsSrchBtnClick((prevVal) => ++prevVal)
        setSearchWord("");
        setSearchParams(prev => {
            prev.set("pgNo", 1)
            prev.set("s", "")
            prev.set("isSrchRes", 0)
            return prev
        }, { replace: true })
    }



    if (isProdErr) {
        customAlert(prodErr);
        return <h2>Something went wrong</h2>
    }

    if (isError) {
        customAlert(error);
        return <h2>Something went wrong</h2>
    }

    return (<Box height={"100%"} width={"100%"}>

        <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 1, mt: 1 }} width={"100%"}>
            <Stack width={"33%"} direction={"row"} alignItems={"center"} gap={1}>
                <BackButton />
                <PathBtns btnsArr={pathBtnsArr} />
            </Stack>
            <Stack direction={"row"} justifyContent="center" alignItems={"center"} gap={2} width={"33%"} >
                <Box mb={0.5}><SearchTxtField width={400} handleOnClear={handleOnClear} variant={"outlined"} searchKeyWord={searchWord}
                    onSearch={onSearch} onBtnClick={onSearchBtnClick} placeholder={`Search Product By Name / AMTC ID / MAT Code / Desc / Manufacturer`} /></Box>
            </Stack>
            <Stack direction={"row"} justifyContent="end" alignItems={"center"} gap={2} width={"33%"} >
                {isSrchRes === 1 ? <></> : <IconButton onClick={onOrderChange}>
                    <SwapVertOutlinedIcon />
                </IconButton>}

            </Stack>
        </Stack>

        <ScrollBox height={"84%"}>
            <Grid container spacing={3}
                direction="row"
                justifyContent="center"
                alignItems="center"
            >
                {(prodData?.prodsArr ?? []).map((i) => <Grid item xs="auto" key={i.id}>
                    <ProductCard i={i} key={i?.id} isComUser={ctxtUser?.isComUser} type='com' comId={comId} /> </Grid>)}
            </Grid>
        </ScrollBox>
        <Stack sx={{ alignItems: "center", mt: 1 }}>
            <Pagination count={Math.ceil(prodData?.totalProdsCount / limit) || 0} color="primary"
                page={pgNo} onChange={handlePageChange} variant="outlined" shape="rounded" />
        </Stack>
    </Box>
    )
}
export default ComProductListPage;